import AnimatedButton from "../ui/animated-button";

const LoginButton = () => {
	return <AnimatedButton href="https://app.everclose.com/api/auth/login">Login</AnimatedButton>;
};

export default LoginButton;
